var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.count),function(i){return _c('v-col',{key:i,attrs:{"sm":_vm.size,"cols":"12"}},[_c('v-skeleton-loader',{attrs:{"type":_vm.type}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }